/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum DescendantsNoteApplicationOption {
  ALL = "ALL",
  NONE = "NONE",
  ROOTS = "ROOTS",
}

export interface BulkArchivePagesInput {
  archiveNote?: string | null;
  areChildrenIncluded?: boolean | null;
  descendantsNoteApplicationOption?: DescendantsNoteApplicationOption | null;
  excludedBranchRootPageIDs?: (any | null)[] | null;
  isSelected?: boolean | null;
  pageID: any;
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ArchivePagesMutation
// ====================================================

export interface ArchivePagesMutation_archivePages {
  taskId: string | null;
  status: boolean;
}

export interface ArchivePagesMutation {
  archivePages: ArchivePagesMutation_archivePages | null;
}

export interface ArchivePagesMutationVariables {
  input: (BulkArchivePagesInput | null)[];
}
